import React from "react";
import CMCalculatorV2 from "../components/CMCalculatorV2";

const CMCalculatorV2App = (props) => <CMCalculatorV2 {...props} />;

export default CMCalculatorV2App;
